<template>
  <div class="swap-auditorium-container">
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div class="section-title">
          {{ swapType == 2 ? "Merge Schedule" : "Swap Auditorium" }}
        </div>
      </div>
      <div class="d-flex align-items-center" style="font-weight: 500">
        <div class="d-flex align-items-center ml-1">
                          <b-form-checkbox
                            v-model="multiSeatDrop"
                            type="checkbox"
                            class="j-checkbox mb-0 pb-0"
                            checked
                          />

                          <label class="mb-0 mr-1">{{ "Multi Drop" }}</label>
                        </div>
                        <div class="d-flex align-items-center ml-1">
                          <b-form-checkbox
                            v-model="autoSaveSession"
                            type="checkbox"
                            class="j-checkbox mb-0 pb-0"
                            checked
                          />

                          <label class="mb-0 mr-1">{{ "Auto Save" }}</label>
                        </div>
      </div>
    </div>

    <div class="white-wrapper pt-2 zoomOut9">
      <div class="row">
        <div
          v-if="!collapseObj.movieInfo"
          class="
            col-12
            sectionName
            d-flex
            justify-content-between
            section-header-border
          "
        >
          <div
            class="fs-17 font-weight-bold section-header-name"
            @click="collapseObj.movieInfo = !collapseObj.movieInfo"
          >
            Movie Info
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.movieInfo"
            @click="collapseObj.movieInfo = !collapseObj.movieInfo"
          ></span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.movieInfo"
            @click="collapseObj.movieInfo = !collapseObj.movieInfo"
          ></span>
        </div>
        <b-collapse v-model="collapseObj.movieInfo" class="px-2 col-12">
          <div class="row">
            <div class="col-12">
              <div class="row">

                <div class="col-6">
                  <div class="row mx-0">
                    <div class="col-4 py-1">
                      <div class="row">
                        <div class="col-4 mr-2">Screen:</div>
                        <div class="col-7 pl-0">
                          <strong
                            >
                            {{ ScheduleDetails.screen_name }}</strong
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-4 py-1">
                      <div class="row">
                        <div class="col-3 mr-3">Show:</div>
                        <div class="col-8 pl-0">
                          <strong
                            >
                            {{ ScheduleDetails.show_time }} | {{ ScheduleDetails.show_date }}</strong
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-4 py-1">
                      <div class="row" v-b-tooltip.hover
                          :title="
                            `${booked_seats_count} Booked / ${unpaid_seats_count} Unpaid / ${totalScreenSeats} Total
                          `
                          ">
                        <div class="col-3 mr-2">Sold:</div>
                        <div class="col-8 pl-0">
                          <strong>{{ booked_seats_count }}B / {{unpaid_seats_count }}U / {{totalScreenSeats }}T</strong>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-1">
                      <div class="row">
                        <div class="col-1 mr-2">Movie:</div>
                        <div class="col-10">
                          <strong>{{
                            ScheduleDetails.movie_name ||
                            ScheduleDetails.movie_title
                          }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <div class="col-5">
                      <div
                        v-if="swapType == 2"
                        class="d-flex align-items-center mt-2"
                      >
                        <div class="dropdown-curve-container">
                          <label :class="selectedShow ? 'shift-up' : ''">
                            {{ $tc("schedule", 2) }}
                          </label>

                          <multiselect
                            v-model="selectedShow"
                            @select="onSelectShow"
                            placeholder=""
                            :options="ScheduleList"
                            :customLabel="setSchDDLabel"
                            track-by="ss_id"
                            :multiple="false"
                            name="Swapshow"
                            id="Swapshow"
                            select-label="Select"
                            deselect-label="Remove"
                          >
                            <span slot="option" slot-scope="props">
                              <span
                                >{{ props.option.ss_start_show_time }} -
                                {{
                                  props.option.ss_end_show_time
                                }}&nbsp;|&nbsp;{{
                                  props.option.screen_name
                                }}</span
                              ><br />
                              <span
                              v-if="moment(props.option.ss_start_date).format('YYYY-MM-DD') != moment(ScheduleDetails.show_date).format('YYYY-MM-DD')"
                                class="text-truncate"
                                style="font-size: 11px !important"
                                >{{ moment(props.option.ss_start_date).format('YYYY-MM-DD') }}
                                <br />
                                </span>
                              <span
                                class="text-truncate"
                                style="font-size: 11px !important"
                                >{{ props.option.movie_title }}</span
                              >
                            </span>
                          </multiselect>
                        </div>
                      </div>
                      <div v-else class="d-flex align-items-center mt-2">
                        <div class="dropdown-curve-container">
                          <label :class="selectedScreen ? 'shift-up' : ''">
                            {{ $tc("screen", 2) }}
                          </label>

                          <multiselect
                            v-model="selectedScreen"
                            @select="onSelectScreen"
                            placeholder=""
                            :options="ScreenList"
                            label="screen_name"
                            track-by="screen_id"
                            :multiple="false"
                            name="screenId"
                            id="screenId"
                            select-label="Select"
                            deselect-label="Remove"
                          >
                            <span
                              slot="option"
                              slot-scope="props"
                              :class="
                                props.option.screenAvailable
                                  ? ''
                                  : 'pointer-events unavailbleScreen'
                              "
                            >
                              <span
                                >{{ props.option.screen_name }}&nbsp;
                                <p
                                  class="unavailbleScreenText text-muted"
                                  v-if="!props.option.screenAvailable"
                                >
                                  Unavailable
                                </p></span
                              >
                            </span>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-3">
                      <div class="mt-3 pt-1 pl-0">
                        <div class="d-flex align-items-center ml-1">
                          <b-form-checkbox
                            v-model="multiSeatDrop"
                            type="checkbox"
                            class="j-checkbox mb-0 pb-0"
                            checked
                          />

                          <label class="mb-0 mr-1">{{ "Multi Drop" }}</label>
                        </div>
                      </div>
                    </div> -->
                    <div class="col-6">
                      <div
                        class="
                          d-flex
                          align-items-center
                          px-4
                          mt-2
                          pt-1
                          mx-auto
                        "
                        v-if="flag"
                      >
                        <button
                          :disabled="
                            totalBookingCount != SWAPED_ALL_SEATS.length
                          "
                          @click.prevent.stop="onClickSaveSwap()"
                          :class="(totalBookingCount != SWAPED_ALL_SEATS.length) ? 'disabledSaveBtn' : ''"
                          class="btn btn-sm btn-primary mr-2"
                        >
                          Save All
                        </button>
                        <button
                          @click.prevent.stop="onClear()"
                          class="btn btn-sm btn-outline-primary mr-2"
                        >
                          Clear All
                        </button>
                        <button
                          @click.prevent.stop="cancelSwap()"
                          class="btn btn-sm btn-primary"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
        <div v-if="flag" class="col-12">
          <hr class="mt-0" />
        </div>

        <div v-if="flag" class="col-12 text-center zoomOut9">
          <div class="row">
            <div class="col-6 border-right-dotted">
              <div
                class="pos-seatlayout mb-3"
                style="height: 100%; max-height: 80vh"
              >
                <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
                  <tr v-if="seatIndex === 0">
                    <td colspan="30">
                      <div class="relative pb-2">
                        <img
                          src="@/assets/img/pos/pos-screen.png"
                          class="img-fluid w-100"
                          style="max-height: 23px"
                        />
                        <span class="fs-12">{{ $t("screen_title") }}</span>
                      </div>
                    </td>
                  </tr>
                  <!-- SLIVER CLASS LABEL -->
                  <tr>
                    <td colspan="22">
                      <div class="pos-seat-class">{{ seat.seatType }}</div>
                    </td>
                  </tr>

                  <tr
                    v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
                    :key="seatRowIndex"
                  >
                    <td
                      v-for="(singleSeat, singleSeatIndex) in seatRow"
                      :key="'index' + singleSeatIndex"
                      @mouseover="onSeatMouseOver(singleSeat)"
                      @mouseleave="showSeatInfo = false"
                    >
                      <!-- v-b-popover.hover.bottom="{
                        customClass: `my-seat-popover zoomOut9`,
                        disabled: !singleSeat.hasOwnProperty('sb_booking_code'),
                          content: `
                          <div class='row fs-13'>
                          <div class='col-5 mr-0 pr-0'><b>Booking Code</b></div>
                          <div class='col-7 ml-0 pl-0'>${seatHoverData.sb_booking_code}</div>
                          <div class='col-5 mr-0 pr-0'><b>Seats:</b></div>
                          <div class='col-7 ml-0 pl-0'> ${seatHoverData.seats.map((x) => x.sl_seat_name).join(',')}</div>`,
                          html: true
                        }" -->
                      <drag
                        :draggable="
                          onSelectSwapSeatFlagClass(singleSeat) && swapSeatFlag
                        "
                        :id="
                          'seat' +
                          (singleSeat.sl_seat_name +
                            seatRowIndex +
                            singleSeatIndex)
                        "
                        :transfer-data="{
                          type: 'old_seat',
                          seat: singleSeat,
                          seatRowIndex: seatRowIndex,
                          typeIndex: seatIndex,
                        }"
                      >
                        <div
                          v-if="singleSeat.srt_id == 2"
                          class="pos-seatNumber"
                        >
                          {{ singleSeat.sl_seat_name }}
                        </div>
                        <div v-else class="pos-seatNumber">
                          {{ singleSeat.sl_seat_name }}
                        </div>
                        <!-- {{singleSeat.seat_reserve_type_id}} -->
                        <div
                          class="pos-seat cursor-pointer"
                          :style="{
                            borderColor:
                              singleSeat.selectStatus == true
                                ? '#01d04a !important'
                                : singleSeat.seat_reserve_type_id == 8
                                ? ''
                                : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                    .sst_seat_color_code + ' !important',
                            backgroundColor:
                              singleSeat.selectStatus == true
                                ? ''
                                : singleSeat.seat_reserve_type_id == 8
                                ? ''
                                : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                    .sst_seat_color_code + ' !important',
                          }"
                          v-on:click="
                            onClickBookedSeats(
                              singleSeat,
                              seatRowIndex,
                              singleSeatIndex,
                              null,
                              null,
                              $event,
                              seatIndex
                            )
                          "
                          v-bind:class="{
                            'normal-seat pointer-events':
                              singleSeat.srt_id == 2,
                            'disabled-other-seats':
                              !onSelectSwapSeatFlagClass(singleSeat) &&
                              swapSeatFlag,
                            selected_swap_seats:
                              onSelectSwapSeatFlagClass(singleSeat) &&
                              swapSeatFlag,
                            'swap_no-border': checkSwapDone(singleSeat),
                            'highlight-seats':
                              highlightSameBookings(singleSeat),
                          }"
                        >
                          <img
                            v-if="checkSwapDone(singleSeat)"
                            src="@/assets/img/icons/green-tick.svg"
                            height="28"
                            width="28"
                          />
                          <img
                            v-else
                            :src="getSeatIconURL(singleSeat)"
                            height="28"
                            width="28"
                          />
                        </div>
                      </drag>
                    </td>
                  </tr>
                </table>

                <div class="swap-btn my-4 text-center">
                  <button
                    v-if="!swapSeatFlag"
                    class="btn btn-sm btn-outline-primary"
                    @click="autoMove()"
                  >
                    Auto Move
                  </button>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div
                class="pos-seatlayout mb-3"
                id="swapSeatLayout"
                style="height: 100%; max-height: 80vh"
              >
                <table
                  v-for="(seat, seatIndex) in seatTypeSwap"
                  :key="seatIndex"
                >
                  <tr v-if="seatIndex === 0">
                    <td colspan="30">
                      <div class="relative pb-2">
                        <img
                          src="@/assets/img/pos/pos-screen.png"
                          class="img-fluid w-100"
                          style="max-height: 23px"
                        />
                        <span class="fs-12">{{ $t("screen_title") }}</span>
                      </div>
                    </td>
                  </tr>
                  <!-- SLIVER CLASS LABEL -->
                  <tr>
                    <td colspan="22">
                      <div class="pos-seat-class">{{ seat.seatType }}</div>
                    </td>
                  </tr>

                  <tr
                    v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
                    :key="seatRowIndex"
                  >
                    <td
                      v-for="(singleSeat, singleSeatIndex) in seatRow"
                      :key="'index' + singleSeatIndex"
                      @click="
                        dropSeatParentFuncation(
                          $event,
                          singleSeat,
                          singleSeatIndex,
                          seatRowIndex,
                          seatIndex,
                          'click'
                        )
                      "
                      @mouseover="onSeatMouseOver(singleSeat)"
                      @mouseleave="showSeatInfo = false"
                    >
                      <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber">
                        {{ singleSeat.sl_seat_name }}
                      </div>
                      <div v-else class="pos-seatNumber">
                        {{ singleSeat.sl_seat_name }}
                      </div>
                      <!-- {{singleSeat.seat_reserve_type_id}} -->
                      <drop
                        @drop="
                          dropSeatParentFuncation(
                            $event,
                            singleSeat,
                            singleSeatIndex,
                            seatRowIndex,
                            seatIndex,
                            'drop'
                          )
                        "
                        class="pos-seat cursor-pointer"
                        :style="{
                          borderColor:
                            singleSeat.selectStatus == true
                              ? '#01d04a !important'
                              : singleSeat.seat_reserve_type_id == 8
                              ? ''
                              : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                  .sst_seat_color_code + ' !important',
                          backgroundColor:
                            singleSeat.selectStatus == true
                              ? ''
                              : singleSeat.seat_reserve_type_id == 8
                              ? ''
                              : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                  .sst_seat_color_code + ' !important',
                        }"
                        v-bind:class="{
                          'reserved-seat taken pointer-events':
                            singleSeat.isVipReserved,
                          'normal-seat pointer-events': singleSeat.srt_id == 2,
                          swapped_seats: getSwapSeats(singleSeat),
                          'highlight-seats': highlightSameBookings(singleSeat),
                        }"
                      >
                        <span
                          class="seatNameSmall"
                          v-if="
                            singleSeat.hasOwnProperty('swap_seat') &&
                            singleSeat.swap_seat &&
                            !swapSeatFlag
                          "
                          >{{ singleSeat.swap_seat.sl_seat_name }}</span
                        >
                        <img
                          v-if="getSwapSeats(singleSeat) && swapSeatFlag"
                          src="@/assets/img/icons/green-tick.svg"
                          height="28"
                          width="28"
                        />
                        <img
                          v-else
                          :src="getSeatIconURL(singleSeat)"
                          height="28"
                          width="28"
                        />
                      </drop>
                    </td>
                  </tr>
                </table>

                <div
                  v-if="!selectedScreen && swapType == 1"
                  class="noScreen"
                  style="height: 100%; max-height: 80vh"
                >
                  <p class="text-muted">Please Select Screen</p>
                </div>
                <div
                  v-else-if="!selectedShow && swapType == 2"
                  class="noScreen"
                  style="height: 100%; max-height: 80vh"
                >
                  <p class="text-muted">Please Select Show</p>
                </div>
                <div
                  v-else-if="seatTypeSwap.length == 0"
                  class="noScreen"
                  style="height: 100%; max-height: 80vh"
                >
                  <p class="text-muted">Seat Layout Not Found</p>
                </div>
                <div
                  class="btn-grp swap-btn my-4 text-center"
                  v-if="swapSeatFlag"
                >
                  <button
                    class="btn btn-sm btn-primary"
                    :class="singleSwapCountFull ? 'disabledSaveBtn' : ''"
                    :disabled="singleSwapCountFull"
                    @click="onClickSaveSingleSwapSession()"
                  >
                    Save
                  </button>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="onClickClearSwap()"
                  >
                    Clear
                  </button>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="onClickCancelSwap()"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <hr class="mt-0" />
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div v-if="(selectedScreen && swapType == 1) || (selectedShow && swapType == 2)" class="float-left mr-4">
                <div class="font-weight-bold">
                  Remaining: {{getSeatTypeCount(seatLayoutData, 1).reduce((accumulator, { count }) => { return accumulator + parseFloat(count)},0)}} 
                </div>
              </div>
              <div v-if="swapSeatFlag">
                <span class="font-weight-bold">Selected Seats:&nbsp;</span>
                <ul class="swap-selected-seats-list">
                  <li
                    v-for="(
                      seatTypeGrp, seatTypeGrpIndex
                    ) in groupedBySeatTypeSelectedSeats"
                    :key="seatTypeGrpIndex"
                  >
                    <span>
                      <img
                        :src="
                          _GetImagePath(seatTypeGrp[1][0].srt_dash_image_url)
                        "
                        height="20"
                        width="20"
                        class="pos-seat-border"
                        :style="{
                          borderColor: '#3876d2 !important',
                          backgroundColor: '#3876d2 !important',
                          zoom: '0.6 !important',
                        }"
                      />
                    </span>
                    {{ seatTypeGrp[1].map((x) => x.sl_seat_name).join(", ") }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-6 d-flex justify-content-end align-item-center">
              <div @click="onClickMoreInfo" class="mr-4 infoBtnClass">
                <span class="info-btn"></span>
              </div>
              <div v-if="(selectedScreen && swapType == 1) || (selectedShow && swapType == 2)" class="float-right mr-4">
                <div class="font-weight-bold">
                  Available: {{getSeatTypeCount(seatLayoutDataSwap, 2).reduce((accumulator, { count }) => { return accumulator + parseFloat(count)},0)}} 
                </div>
              </div>
              <div v-if="swapSeatFlag" class="float-right">
                <div class="font-weight-bold">
                  &nbsp;{{ selectedSwapSeatsCount }} /
                  {{ SELECTED_BOOKED_SEATS.length }}&nbsp;Seat Swaped
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center mt-5" v-if="flag && false">
          <button
            :disabled="totalBookingCount != SWAPED_ALL_SEATS.length"
            @click.prevent.stop="OnSave()"
            class="btn btn-sm btn-primary"
          >
            Save
          </button>
          <button
            @click.prevent.stop="onClear()"
            class="btn btn-sm btn-outline-primary"
          >
            Clear
          </button>
          <button
            @click.prevent.stop="cancelSwap()"
            class="btn btn-sm btn-primary"
          >
            Back
          </button>
        </div>
      </div>
    </div>
     <b-modal
      id="swapInfo"
      ref="swapInfo"
      title="Swap Details"
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
    
      <div class="pb-1" v-if="(selectedScreen && swapType == 1) || (selectedShow && swapType == 2)">
         <div class="table_wrapper" v-if="groupedBookingsArray.length > 0">
            <div class="mb-4 swc-report">
              <table
                class="w-100 swc-report-table border text-left"
                border="1"
              >
                <thead>
                  <tr>
                    <th>Booking Code</th>
                    <th>Old Seats</th>
                    <th>Swap Seats <span class="text-muted fs-12">Total ({{SWAPED_ALL_SEATS.length}})</span></th>
                  </tr>
                </thead>
                <tbody class="sph-report">
                  <tr
                    v-for="(booking,
                    bookingIndex) in groupedBookingsArray"
                    :key="bookingIndex"
                  >
                    <td>
                      {{booking.sb_booking_code}} <span v-if="booking.sb_booking_code && booking.reservation_id && booking.sb_booking_code == booking.reservation_id" class="text-muted fs-12">&nbsp;(Unpaid)</span>
                      <span @click="gotoBookedSeats(booking.sb_booking_code)">
                        <img
                        src="@/assets/img/icons/open-link-blue.svg"
                        height="15"
                        width="15"
                        style="margin-bottom: 5px"
                      />
                      </span>
                    </td>
                    <td>
                      <ul class="swap-selected-seats-list" style="white-space: normal">
                  <li
                    v-for="(
                      seatTypeGrp, seatTypeGrpIndex
                    ) in groupedBySeatTypeInfo(booking.seats.map((x) => x.swap_seat))"
                    :key="seatTypeGrpIndex"
                  >
                    <span>
                      <img
                        :src="
                          _GetImagePath(seatTypeGrp[1][0].srt_dash_image_url)
                        "
                        height="20"
                        width="20"
                        class="pos-seat-border"
                        :style="{
                          borderColor: '#3876d2 !important',
                          backgroundColor: '#3876d2 !important',
                          zoom: '0.6 !important',
                        }"
                      />
                    </span>
                    {{ seatTypeGrp[1].map((x) => x.sl_seat_name).join(", ") }}
                  </li>
                </ul>
                    </td>
                    <td>
                      <ul class="swap-selected-seats-list" style="white-space: normal">
                  <li
                    v-for="(
                      seatTypeGrp, seatTypeGrpIndex
                    ) in groupedBySeatTypeInfo(booking.seats)"
                    :key="seatTypeGrpIndex"
                  >
                    <span>
                      <img
                        :src="
                          _GetImagePath(seatTypeGrp[1][0].srt_dash_image_url)
                        "
                        height="20"
                        width="20"
                        class="pos-seat-border"
                        :style="{
                          borderColor: '#3876d2 !important',
                          backgroundColor: '#3876d2 !important',
                          zoom: '0.6 !important',
                        }"
                      />
                    </span>
                    {{ seatTypeGrp[1].map((x) => x.sl_seat_name).join(", ") }}
                  </li>
                </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        <div class="row" style="zoom: 0.9;">
          <div class="col-6">
            <div class="mb-4 swc-report">
              Remaining Booked Seats <span class="text-muted fs-12">(Current Screen)</span>
              <table
                class="w-100 swc-report-table border text-left"
                border="1"
              >
                <thead>
                  <tr>
                    <th>Seat Type</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody class="sph-report">
                  <tr
                    v-for="(seatType,
                    seatTypeIndex) in getSeatTypeCount(seatLayoutData, 1)"
                    :key="seatTypeIndex"
                  >
                    <td>
                      {{seatType.seat_type}}
                    </td>
                    <td>
                      {{seatType.count}}
                    </td>
                  </tr>
                  <tr class="grey">
                    <th>Total</th>
                    <th>{{getSeatTypeCount(seatLayoutData, 1).reduce((accumulator, { count }) => { return accumulator + parseFloat(count)},0)}}</th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-6">
             <div class="mb-4 swc-report">
               Seats Available <span class="text-muted fs-12">(Swap Screen)</span>
              <table
                class="w-100 swc-report-table border text-left"
                border="1"
              >
                <thead>
                  <tr>
                    <th>Seat Type</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody class="sph-report">
                  <tr
                    v-for="(seatType,
                    seatTypeIndex) in getSeatTypeCount(seatLayoutDataSwap, 2)"
                    :key="seatTypeIndex"
                  >
                    <td>
                      {{seatType.seat_type}}
                    </td>
                    <td>
                      {{seatType.count}}
                    </td>
                  </tr>
                  <tr class="grey">
                    <th>Total</th>
                    <th>{{getSeatTypeCount(seatLayoutDataSwap, 2).reduce((accumulator, { count }) => { return accumulator + parseFloat(count)},0)}}</th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center p-5">
        NO INFORMATION AVAILABLE
      </div>
       <div class="w-100 text-center">
          <button
          class="btn btn-sm btn-outline-primary mx-auto"
          @click.prevent.stop="$bvModal.hide('swapInfo')"
        >
          Close
        </button>
        </div>
    </b-modal>
     <b-modal
      id="swapConfirmation"
      ref="swapConfirmation"
      title="Confirmation"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mt-3 font-weight-bold">
          Are you sure you want to
          {{ swapType == 2 ? "Merge" : "Swap" }} schedule ?
        </p>

        <div class="col-12 mb-3">
          <div class="row mx-auto">
            <div class="col-11 mx-auto">
              <div class="input-material-textarea">
                <textarea
                  v-model="swapReason"
                />
                <label>Reason (Required)</label>
              </div>
            </div>
          </div>
        </div>

        <button
          class="btn btn-sm btn-outline-danger"
          @click.prevent.stop="$bvModal.hide('swapConfirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-sm btn-primary"
          :class="
            disableBtn || !swapReason
              ? 'disSwapBtn'
              : ''
          "
          :disabled="disableBtn || !swapReason"
          @click.prevent.stop="OnSave()"
        >
           {{ swapType == 2 ? "Merge" : "Swap" }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import scheduleService from "@/services/scheduleService";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import ExhibitorService from "@/services/ExhibitorService";
import ScreenService from "@/services/ScreenService";
import _ from "lodash";
import moment from "moment";
import { groupBy } from "lodash";
import { getSeatLayoutModified } from "@/helper/collection";

export default {
  data() {
    return {
      totalScreenSeats: 0,
      swapReason: '',
      disableBtn:false,
      autoSaveSession: false,
      selectedShow: "",
      selectedShowId: null,
      ScheduleList: [],
      selectedShowDetails: [],
      swapType: 1, //1 SWAP 2: MERGE
      multiSeatDrop: false,
      collapseObj: {
        movieInfo: true,
      },
      seatTypes: [
        {
          seatName: "Regular Seat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
          imageURL: "",
        },
        {
          seatName: "No Seat",
          size: 1,
          value: 2,
          imageClass: "no-seat",
          imageURL: "",
        },
        {
          seatName: "Wheel Chair",
          size: 1,
          value: 3,
          imageClass: "wheelchair",
          imageURL: "",
        },
        {
          seatName: "VIP Seat",
          size: 1,
          value: 5,
          imageClass: "vip-seat",
          imageURL: "",
        },
        // {
        //   seatName: "Couple Seats",
        //   size: 6,
        //   imageClass: "love-seat",
        // },
        {
          seatName: "Only POS",
          size: 1,
          value: 9,
          imageClass: "pointofsale",
          imageURL: "",
        },
        {
          seatName: "Sofa",
          size: 1,
          value: 10,
          imageClass: "sofa-seat",
          imageURL: "",
        },
        {
          seatName: "Recliner",
          size: 1,
          value: 11,
          imageClass: "recliner",
          imageURL: "",
        },
        // {
        //   seatName: "Blocked Seat",
        //   size: 1,
        //   value: 12,
        //   imageClass: "block-seat",
        // },
        {
          seatName: "Broken Seat",
          size: 1,
          value: 13,
          imageClass: "broken-seat",
          imageURL: "",
        },
      ],
      unpaid_seats_count: 0,
      booked_seats_count: 0,
      activeSeatTypes: [],
      seatLayoutData: [],
      seatLayoutDataSwap: [],
      selectedScreenId: null,
      selectedScreen: "",
      btenable: false,
      submitted: false,
      flag: false,
      SetAllSeats: [],
      Seats: [],
      CinemasList: [],
      ScreenList: [],
      SELECTED_SEATS: [],
      SELECTED_BOOKED_SEATS: [],
      SWAPED_BOOKED_SEATS: [],
      SWAPED_ALL_SEATS: [],
      selectedMoviesInScreens: [],
      swapSeatFlag: false,
      seatHoverData: {
        sb_booking_code: "",
        seats: [],
        customer_details: "",
      },
      routerParams: {
        md_id: null,
        screen_id: null,
        ss_id: null,
      },
      showSeatInfo: false,
      ScheduleDetails: {
        md_id: null,
        screen_id: null,
        movie_title: "",
        movie_name: "",
        screen_name: "",
        cinema_name: "",
        show_time: "",
        show_date: "",
      },
    };
  },
  created() {
      // window.addEventListener('beforeunload', (event) => {
      //   event.preventDefault();
      //   event.returnValue = '';
      //   this.enableSchedule();
      // });

      window.addEventListener('unload', (event) => {
        this.enableSchedule();
      });
    },
   beforeDestroy() {
    this.enableSchedule();
  },
  beforeMount() {
    const { md_id, screen_id, ss_id, type } = this.$route.params;
    this.getSeatTypes();
    if (!md_id || !screen_id || !ss_id || !type) {
      this.$router.go(-1);
    } else {
      this.swapType = type;
      this.routerParams["md_id"] = md_id;
      this.routerParams["screen_id"] = screen_id;
      this.routerParams["ss_id"] = ss_id;
      this.getScheduleShowDetails(ss_id);
      this.getSeatLayoutData(ss_id, md_id, screen_id);
      if (type == 1) {
        this.getAvailabelScreenList(ss_id);
      } else if (type == 2) {
        this.getAvailabelScheduleList(ss_id);
      } else {
        this.$toasted.show("Type Details Not Found");
        this.$router.go(-1);
      }
    }
    this.SetAllSeats = [];
  },

  computed: {
    groupedBookingsArray() {
      let finalProcessingArray = [];
      let groupedFinalArray = [];
      let finalSubmitArray = [];

      finalProcessingArray = [
          ...new Map(
            this.SWAPED_ALL_SEATS.map((item) => [item["sl_id"], item])
          ).values(),
        ];

        groupedFinalArray = _.toPairs(
          _.groupBy(
            finalProcessingArray.filter((x) => x),
            "sb_booking_code"
          )
        );

        groupedFinalArray.map((group) => {
          console.log("group", group);
          let bookingObj = {
            sb_booking_code: "",
            reservation_id: "",
            sb_id: null,
            schedule_show_id: null,
            new_schedule_show_id: null,
            md_id: null,
            old_screen_id: null,
            new_screen_id: null,
            swapType: this.swapType,
            seats: [],
          };
          group[1].map((seats, index) => {
            if (index == 0) {
              bookingObj["sb_booking_code"] = seats.swap_seat.sb_booking_code;
              bookingObj["reservation_id"] = seats.swap_seat.reservation_id;
              bookingObj["sb_id"] = !!seats.swap_seat.sb_id ? seats.swap_seat.sb_id : null;
              bookingObj["schedule_show_id"] = seats.swap_seat.schedule_show_id;
              bookingObj["new_schedule_show_id"] = this.swapType == 2 ? this.selectedShowId : null;
              bookingObj["old_screen_id"] = seats.swap_seat.screen_id;
              bookingObj["new_screen_id"] = seats.screen_id;
              bookingObj["md_id"] = this.ScheduleDetails.md_id;
            }
            delete seats.screenSeatType;
            bookingObj["seats"].push(seats);
          });
          finalSubmitArray.push(bookingObj);
        });
        return finalSubmitArray;
    },
    totalBookingCount() {
      return this.unpaid_seats_count + this.booked_seats_count;
    },
    checkAllowSave() {
      if(SWAPED_ALL_SEATS.length && totalBookingCount == SWAPED_ALL_SEATS.length) {
        return true;
      } else {
        return false;
      }
    },
    selected_booking_details() {
      let obj = {
        sb_booking_code: "",
      };
      if (this.SELECTED_BOOKED_SEATS.length > 0) {
        obj["sb_booking_code"] = this.SELECTED_BOOKED_SEATS[0].sb_booking_code;
      }
      return obj;
    },
    groupedBySeatTypeSelectedSeats() {
      let selected_seats = this.SELECTED_BOOKED_SEATS;
      let selectedSeats = [];
      if (selected_seats.length > 0) {
        selectedSeats = _.toPairs(
          _.groupBy(
            selected_seats.filter((x) => x),
            "srt_id"
          )
        );
      }
      return selectedSeats;
    },
    singleSwapCountFull() {
      let sb_booking_code = [];
      let tempArray = [];
      sb_booking_code = this.SELECTED_BOOKED_SEATS.map(
        (x) => x.sb_booking_code
      );

      tempArray = this.SWAPED_ALL_SEATS.filter((x) =>
        sb_booking_code.includes(x.sb_booking_code)
      );

      if (tempArray.length == this.SELECTED_BOOKED_SEATS.length) {
        return false;
      } else {
        return true;
      }
    },
    selectedSwapSeatsCount() {
      let sb_booking_code = [];
      let tempArray = [];
      sb_booking_code = this.SELECTED_BOOKED_SEATS.map(
        (x) => x.sb_booking_code
      );
      tempArray = this.SWAPED_ALL_SEATS.filter((x) =>
        sb_booking_code.includes(x.sb_booking_code)
      );
      return tempArray.length;
    },
    seatTypeStore() {
      return this.$store.getters.SEAT_LAYOUT_DATA;
    },
    seatType() {
      return this.seatLayoutData;
    },
    seatTypeSwap() {
      return this.seatLayoutDataSwap;
    },
  },
  methods: {
    moment,
    enableSchedule() {
      let disablePayload = {
        md_id: this.routerParams.md_id,
        ss_id: this.routerParams.ss_id,
        type: 2
      };

     MasterService.EnableDisableSchedule(disablePayload).then((response) => {
       const {data} = response;
     }).catch((err) => {
       console.log('Error:', err);
     })
    },
    gotoBookedSeats(bookingCode) {
      console.log('CLICKED BOOKING CODE', bookingCode);
      this.seatLayoutData.map((x, typeIndex) => {
          x.seatsFinal.map((y, rowIndex) => {
            y.map((z, singleSeatIndex) => {
              if(z.hasOwnProperty('sb_booking_code') && z.sb_booking_code && z.sb_booking_code == bookingCode) {
                this.SELECTED_BOOKED_SEATS = [];
                this.onClickBookedSeats(
                              z,
                              rowIndex,
                              singleSeatIndex,
                              null,
                              null,
                              null,
                              typeIndex
                            )
                            this.$refs.swapInfo.hide();
                            return;
              }
            })
          })
      })
              
    },
    onClickMoreInfo() {
      this.$refs.swapInfo.show();
    },
    onClickSaveSwap() {
      this.$refs.swapConfirmation.show();
    },
    getSeatTypeCount(arr, type) {
      let seatLayout = arr;
      let seatTypeArray = [];
     
      seatLayout.map((x, xIndex) => {
        x.seatsFinal.map((y, yIndex) => {
          y.map((z) => {
            let condition = type == 1 ? z.seat_reserve_type_id == 8 : type == 2 ?  z.seat_reserve_type_id != 8 : false
            if(condition) {
                let checkIndex = seatTypeArray.findIndex((x) => x.srt_id == z.srt_id);
                  if(checkIndex > -1) {
                   seatTypeArray[checkIndex].count++;
                   seatTypeArray[checkIndex].sl_id_array.push(z.sl_id)
                  } else {
                      let countObj = {
                        srt_id: z.srt_id,
                        seat_type: z.srt_name,
                        count: 1,
                        sl_id_array: []
                      }
                      countObj['sl_id_array'].push(z.sl_id)
                      seatTypeArray.push(countObj)
                  }
            }
          });
        });
      });
      if(type == 1) {
        seatTypeArray.forEach((x) => {
          let swapSeatsCount = this.SWAPED_ALL_SEATS.filter((y) => x.sl_id_array.includes(y.swap_seat.sl_id)) 
          x['count'] = x.count - swapSeatsCount.length;
        })
      }

      return seatTypeArray.filter((x) => x.srt_id != 2);
    },
    groupedBySeatTypeInfo(arr) {
      let selected_seats = arr;
      let selectedSeats = [];
      if (selected_seats.length > 0) {
        selectedSeats = _.toPairs(
          _.groupBy(
            selected_seats.filter((x) => x),
            "srt_id"
          )
        );
      }
      return selectedSeats;
    },
    setSchDDLabel(e) {
      return `${e.ss_start_show_time} - ${e.ss_end_show_time}  | ${e.screen_name}`;
    },
    checkOccupied(dropSeat) {
      let errorCount = 0
      if(dropSeat.hasOwnProperty('seat_reserve_type_id') && dropSeat.seat_reserve_type_id == 8) {
        errorCount++;
      } else if(dropSeat.hasOwnProperty('sb_booking_code') && dropSeat.sb_booking_code) {
        errorCount++;
      }

      if(errorCount > 0) {
        return true
      } else {
        return false
      }
    },
    highlightSameBookings(singleSeats) {
      if (
        this.showSeatInfo &&
        singleSeats.hasOwnProperty("sb_booking_code") &&
        singleSeats.sb_booking_code &&
        singleSeats.sb_booking_code == this.seatHoverData.sb_booking_code
      ) {
        return true;
      } else {
        return false;
      }
    },
    onSeatMouseOver(singleSeat) {
      if (
        singleSeat.hasOwnProperty("sb_booking_code") &&
        singleSeat.sb_booking_code
      ) {
        this.showSeatInfo = true;
        this.seatHoverData["sb_booking_code"] = singleSeat.sb_booking_code;
        let tempSeatArray = [];
        this.seatLayoutData.map((x, indexX) => {
          x.seatsFinal.map((y, indexY) => {
            y.map((z, indexZ) => {
              if (
                z.sb_booking_code &&
                z.sb_booking_code == singleSeat.sb_booking_code
              ) {
                tempSeatArray.push(z);
              }
            });
          });
        });
        this.seatHoverData.seats = _.cloneDeep(tempSeatArray);
      } else {
        this.showSeatInfo = false;
      }
    },
    checkSwapAvailable(seat, swapSeat) {
      if (
        !this.SWAPED_ALL_SEATS.some((s) => s.swap_seat.sl_id == seat.sl_id) &&
        ![8, 2, 12, 13].includes(swapSeat.seat_reserve_type_id)
      ) {
        return true;
      } else {
        return false;
      }
    },
    onClickCancelSwap() {
      this.onClickClearSwap();
      this.swapSeatFlag = false;
    },
    cancelSwap() {
      this.$router.go(-1);
    },
     autoMove() {
      if (
        (this.selectedScreen && this.swapType == 1) ||
        (this.selectedShow && this.swapType == 2)
      ) {
        this.seatLayoutData.map((x, typeIndex) => {
          x.seatsFinal.map((y, rowIndex) => {
            y.map((z, singleSeatIndex) => {
              if (z.hasOwnProperty("sb_booking_code") && z.sb_booking_code && !this.SWAPED_ALL_SEATS.some(
                  (swpS) =>
                    swpS.hasOwnProperty("swap_seat") &&
                    swpS.swap_seat.sl_id == z.sl_id
                )) {
                this.swapSeatFlag = true;
                let transferData = {
                  type: "old_seat",
                  seat: z,
                  seatRowIndex: rowIndex,
                  typeIndex: typeIndex,
                };
                let count = 0;

                this.SELECTED_BOOKED_SEATS = [];

                this.seatLayoutData.map((xz, indexX) => {
                  xz.seatsFinal.map((yz, indexY) => {
                    yz.map((zz, indexZ) => {
                      if (
                        zz.sb_booking_code &&
                        zz.sb_booking_code == z.sb_booking_code
                      ) {
                        this.swapSeatFlag = true;
                        zz["seatRowIndex"] = rowIndex;
                        zz["typeIndex"] = typeIndex;
                        this.SELECTED_BOOKED_SEATS.push(zz);
                      }
                    });
                  });
                });

                this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                  x1.seatsFinal.map((y1, rowIndex1) => {
                    let singleSeatIndex1 = y1.findIndex(
                      (z1) => z.sl_seat_name == z1.sl_seat_name
                    );
                    if (singleSeatIndex1 > -1) {
                      //DROP SEAT
                      let seat = this.seatLayoutDataSwap[typeIndex1].seatsFinal[rowIndex1][singleSeatIndex1];
                      if (this.checkSwapAvailable(z, seat)) {
                        
                        let response = this.autoMoveMultiDrop(transferData, seat, singleSeatIndex1, rowIndex1, typeIndex1)

                        if(response) {
                          count++;
                          return;
                        }
                      }
                    }
                  });
                });

                if (count == 0) {
                  this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                    x1.seatsFinal.map((y1, rowIndex1) => {
                      let singleSeatIndex1 = y1.findIndex(
                        (z1) => this.SELECTED_BOOKED_SEATS.some((s) => s.sl_col_num == z1.sl_col_num &&
                          s.sl_row_num == z1.sl_row_num) 
                      );
                      if (singleSeatIndex1 > -1) {
                        let seat =
                          this.seatLayoutDataSwap[typeIndex1].seatsFinal[
                            rowIndex1
                          ][singleSeatIndex1];
                        if (this.checkSwapAvailable(z, seat)) {
                          let response = this.autoMoveMultiDrop(transferData, seat, singleSeatIndex1, rowIndex1, typeIndex1)

                        if(response) {
                          count++;
                          return;
                        }
                        }
                      }
                    });
                  });
                }

                if (count == 0) {
                  this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                    x1.seatsFinal.map((y1, rowIndex1) => {
                      y1.map((z1, singleSeatIndex1) => {
                        if (this.checkSwapAvailable(z, z1)) {
                          let response = this.autoMoveMultiDrop(transferData, z1, singleSeatIndex1, rowIndex1, typeIndex1)
                          console.log('RANDOM MULTI', response, z.sl_seat_name);
                         if(response) {
                          count++;
                          return;
                        }
                        }
                      });
                    });
                  });
                }

                if (count == 0) {
                  this.SELECTED_BOOKED_SEATS.map((sbs) => {
                    this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                    x1.seatsFinal.map((y1, rowIndex1) => {
                      y1.map((z1, singleSeatIndex1) => {
                        if (this.checkSwapAvailable(sbs, z1)) {
                          transferData['seat'] = sbs
                          transferData['seatRowIndex'] = sbs.seatRowIndex
                          transferData['typeIndex'] = sbs.typeIndex
                          this.handleDrop(
                            transferData,
                            z1,
                            singleSeatIndex1,
                            rowIndex1,
                            typeIndex1
                          );
                        count++;
                        return;
                        }
                      });
                    });
                  });
                  })
                }
              } else {
                // console.log('NO TRANSACTION FOR THIS SEAT', z.sl_seat_name);
              }
            });
          });
        });
        this.swapSeatFlag = false;
      } else {
        if (this.swapType == 2) {
          this.$toasted.show("Please Select Show");
        } else if (this.swapType == 1) {
          this.$toasted.show("Please Select Screen");
        }
      }
    },
    _autoMove() {
      if (
        (this.selectedScreen && this.swapType == 1) ||
        (this.selectedShow && this.swapType == 2)
      ) {
        this.seatLayoutData.map((x, typeIndex) => {
          x.seatsFinal.map((y, rowIndex) => {
            y.map((z, singleSeatIndex) => {
              if (z.hasOwnProperty("sb_booking_code") && z.sb_booking_code) {
                this.swapSeatFlag = true;
                let transferData = {
                  type: "old_seat",
                  seat: z,
                  seatRowIndex: rowIndex,
                  typeIndex: typeIndex,
                };
                let count = 0;
                this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                  x1.seatsFinal.map((y1, rowIndex1) => {
                    let singleSeatIndex1 = y1.findIndex(
                      (z1) => z.sl_seat_name == z1.sl_seat_name
                    );
                    if (singleSeatIndex1 > -1) {
                      let seat =
                        this.seatLayoutDataSwap[typeIndex1].seatsFinal[
                          rowIndex1
                        ][singleSeatIndex1];
                      if (this.checkSwapAvailable(z, seat)) {
                        this.handleDrop(
                          transferData,
                          seat,
                          singleSeatIndex1,
                          rowIndex1,
                          typeIndex1
                        );
                        count++;
                        return;
                      }
                    }
                  });
                });

                if (count == 0) {
                  this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                    x1.seatsFinal.map((y1, rowIndex1) => {
                      let singleSeatIndex1 = y1.findIndex(
                        (z1) =>
                          z.sl_col_num == z1.sl_col_num &&
                          z.sl_row_num == z1.sl_row_num
                      );
                      if (singleSeatIndex1 > -1) {
                        let seat =
                          this.seatLayoutDataSwap[typeIndex1].seatsFinal[
                            rowIndex1
                          ][singleSeatIndex1];
                        if (this.checkSwapAvailable(z, seat)) {
                          this.handleDrop(
                            transferData,
                            seat,
                            singleSeatIndex1,
                            rowIndex1,
                            typeIndex1
                          );
                          count++;
                          return;
                        }
                      }
                    });
                  });
                }

                if (count == 0) {
                  this.seatLayoutDataSwap.map((x1, typeIndex1) => {
                    x1.seatsFinal.map((y1, rowIndex1) => {
                      y1.map((z1, singleSeatIndex1) => {
                        if (this.checkSwapAvailable(z, z1)) {
                          this.handleDrop(
                            transferData,
                            z1,
                            singleSeatIndex1,
                            rowIndex1,
                            typeIndex1
                          );
                          count++;
                          return;
                        }
                      });
                    });
                  });
                }
              } else {
                // console.log('NO TRANSACTION FOR THIS SEAT', z.sl_seat_name);
              }
            });
          });
        });
        this.swapSeatFlag = false;
      } else {
        if (this.swapType == 2) {
          this.$toasted.show("Please Select Show");
        } else if (this.swapType == 1) {
          this.$toasted.show("Please Select Screen");
        }
      }
    },
    onClickDrop(dropSeat, singleSeatIndex, rowIndex, typeIndex) {
      let count = 0;
      if (this.swapSeatFlag && this.SELECTED_BOOKED_SEATS.length > 0 && ![2, 12, 13].includes(dropSeat.seat_reserve_type_id)) {
        if (
          this.SWAPED_ALL_SEATS.some((y) => y.sl_id == dropSeat.sl_id) &&
          this.SELECTED_BOOKED_SEATS.some(
            (y) =>
              dropSeat.hasOwnProperty("swap_seat") &&
              dropSeat.swap_seat.sl_id &&
              y.sl_id == dropSeat.swap_seat.sl_id
          )
        ) {
          this.clearSelectedSwappedSeat(
            dropSeat,
            singleSeatIndex,
            rowIndex,
            typeIndex
          );
        } else {
          console.log("COMING ON FIRST IF");
          this.SELECTED_BOOKED_SEATS.map((x) => {
            if (
              (this.SWAPED_ALL_SEATS.length == 0 ||
                !this.SWAPED_ALL_SEATS.some(
                  (y) =>
                    y.hasOwnProperty("swap_seat") &&
                    y.swap_seat.sl_id == x.sl_id
                )) &&
              count == 0
            ) {
              let transferData = {
                type: "old_seat",
                seat: x,
                seatRowIndex: x.seatRowIndex,
                typeIndex: x.typeIndex,
              };
              count++;
              this.handleDrop(
                transferData,
                dropSeat,
                singleSeatIndex,
                rowIndex,
                typeIndex,
                true
              );
              this.$forceUpdate();
            } else {
              console.log("COMING ELSE OF CHECK SOME OF ARRAY");
            }
          });
        }
      } else {
        console.log("COMING ELSE OF FIRST CHECK");
      }
    },
    clearSelectedSwappedSeat(dropSeat, singleSeatIndex, rowIndex, typeIndex) {
      if (dropSeat.hasOwnProperty("swap_seat")) {
        let selected_booked_seat_ids = [];

        if (dropSeat.hasOwnProperty("swap_seat") && dropSeat.swap_seat.sl_id) {
          selected_booked_seat_ids.push(dropSeat.swap_seat.sl_id);
        }

        this.SWAPED_ALL_SEATS.filter(
          (x) =>
            x.hasOwnProperty("swap_seat") &&
            selected_booked_seat_ids.includes(x.swap_seat.sl_id)
        ).forEach((x) =>
          this.SWAPED_ALL_SEATS.splice(this.SWAPED_ALL_SEATS.indexOf(x), 1)
        );

        this.SWAPED_BOOKED_SEATS.filter(
          (x) =>
            x.hasOwnProperty("swap_seat") &&
            selected_booked_seat_ids.includes(x.swap_seat.sl_id)
        ).forEach((x) =>
          this.SWAPED_BOOKED_SEATS.splice(
            this.SWAPED_BOOKED_SEATS.indexOf(x),
            1
          )
        );

        console.log(
          "clearSelectedSwappedSeat this.SWAPED_ALL_SEATS",
          this.SWAPED_ALL_SEATS
        );

        dropSeat["seat_reserve_type_id"] = dropSeat.old_seat_reserve_type_id;
        delete dropSeat["swap_details"];
        delete dropSeat["swap_seat"];
        delete dropSeat["old_seat_reserve_type_id"];
        delete dropSeat["sb_booking_code"];
        this.$forceUpdate();
      }
    },
    checkSwapDone(singleSeat) {
      if (
        this.SWAPED_ALL_SEATS.some(
          (x) =>
            x.hasOwnProperty("swap_seat") &&
            x.swap_seat.sl_id == singleSeat.sl_id
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSwapSeats(singleSeat) {
      if (
        this.SWAPED_ALL_SEATS.some((x) => x.sl_id == singleSeat.sl_id) &&
        this.SELECTED_BOOKED_SEATS.some(
          (y) => y.sb_booking_code == singleSeat.sb_booking_code
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    onClickSaveSingleSwapSession() {
      if (!this.singleSwapCountFull) {
        this.swapSeatFlag = false;
        this.SWAPED_BOOKED_SEATS = [];
      } else {
        return this.$toasted.show(
          "Please Swap all Seats for selected transactions"
        );
      }
    },
    onClickClearSwap() {
      let selected_booked_seat_ids = this.SELECTED_BOOKED_SEATS.map(
        (x) => x.sl_id
      );

      this.SWAPED_ALL_SEATS.filter(
        (x) =>
          x.hasOwnProperty("swap_seat") &&
          selected_booked_seat_ids.includes(x.swap_seat.sl_id)
      ).forEach((x) =>
        this.SWAPED_ALL_SEATS.splice(this.SWAPED_ALL_SEATS.indexOf(x), 1)
      );

      this.seatLayoutDataSwap.map((x, xIndex) => {
        x.seatsFinal.map((y, yIndex) => {
          y.map((z) => {
            if (
              z.hasOwnProperty("swap_seat") &&
              selected_booked_seat_ids.includes(z.swap_seat.sl_id)
            ) {
              z["seat_reserve_type_id"] = z.old_seat_reserve_type_id;
              delete z.swap_details;
              delete z.swap_seat;
              delete z.old_seat_reserve_type_id;
              delete z.sb_booking_code;
              this.$forceUpdate();
            }
          });
        });
      });
    },
     autoMoveMultiDrop(
      data,
      dropSeat,
      singleSeatIndex,
      rowIndex,
      typeIndex,
      type
    ) {
         console.log('singleSeatIndex, rowIndex, typeIndex', singleSeatIndex, rowIndex, typeIndex);

          let errorCount = 0;

          let qty = this.SELECTED_BOOKED_SEATS.length;

          let checkIndexArray = [];

          for (
            let check = singleSeatIndex;
            check < singleSeatIndex + qty;
            check++
          ) {
            let dSeat = this.seatLayoutDataSwap[typeIndex].seatsFinal[rowIndex][check];

            let count = 0;

            if (dSeat && ![8, 2, 12, 13].includes(dSeat.seat_reserve_type_id)) {
              this.SELECTED_BOOKED_SEATS.map((seat) => {
                if (
                  (checkIndexArray.length == 0 ||
                    !checkIndexArray.some(
                      (y) =>
                        y.hasOwnProperty("swap_seat") &&
                        y.swap_seat.sl_id == seat.sl_id
                    )) &&
                  count == 0 &&
                  !this.checkSwapDone(seat)
                ) {
                  delete seat.screenSeatType;
                  dSeat["swap_seat"] = _.cloneDeep(seat);
                  dSeat["old_seat_reserve_type_id"] =
                    dSeat.seat_reserve_type_id;
                  dSeat["seat_reserve_type_id"] = 8;
                  dSeat["swapped"] = true;
                  dSeat["sb_booking_code"] = seat.sb_booking_code;
                  count++;
                  checkIndexArray.push(dSeat);
                } else {
                  console.log("COMING ELSE OF CHECK SOME OF ARRAY");
                }
              });
            } else {
              errorCount++;
            }
          }

          if (errorCount > 0) {
            errorCount = 0;
            let startIndex = singleSeatIndex - 1;
            let remainingQty = qty - checkIndexArray.length;
            for (
              let check = startIndex;
              check > startIndex - remainingQty;
              check--
            ) {
              let dSeat =
                this.seatLayoutDataSwap[typeIndex].seatsFinal[rowIndex][check];
              let count = 0;
              if (
                dSeat &&
                ![8, 2, 12, 13].includes(dSeat.seat_reserve_type_id)
              ) {
                this.SELECTED_BOOKED_SEATS.map((seat) => {
                  if (
                    (checkIndexArray.length == 0 ||
                      !checkIndexArray.some(
                        (y) =>
                          y.hasOwnProperty("swap_seat") &&
                          y.swap_seat.sl_id == seat.sl_id
                      )) &&
                    count == 0 &&
                    !this.checkSwapDone(seat)
                  ) {
                    delete seat.screenSeatType;
                    dSeat["swap_seat"] = _.cloneDeep(seat);
                    dSeat["old_seat_reserve_type_id"] =
                      dSeat.seat_reserve_type_id;
                    dSeat["seat_reserve_type_id"] = 8;
                    dSeat["swapped"] = true;
                    dSeat["sb_booking_code"] = seat.sb_booking_code;
                    count++;
                    checkIndexArray.push(dSeat);
                  } else {
                    console.log("COMING ELSE OF CHECK SOME OF ARRAY");
                  }
                });
              } else {
                errorCount++;
              }
            }
          }

          if (errorCount > 0) {
            checkIndexArray = [];
            this.onClickClearSwap();
            // this.$toasted.show("No Space");
            this.$forceUpdate();
            return false;
          } else {
            checkIndexArray.map((x) => {
              this.SWAPED_BOOKED_SEATS.push(x);
              this.SWAPED_ALL_SEATS.push(x);
              if(!this.singleSwapCountFull && this.autoSaveSession) {
              this.onClickSaveSingleSwapSession();
            }
              this.$forceUpdate();
            });
            console.log("checkIndexArray", checkIndexArray);
            console.log("this.SWAPED_BOOKED_SEATS", this.SWAPED_BOOKED_SEATS);
            console.log("this.SWAPED_ALL_SEATS", this.SWAPED_ALL_SEATS);
            return true;
          }
        
    },
    dropSeatParentFuncation(
      data,
      dropSeat,
      singleSeatIndex,
      rowIndex,
      typeIndex,
      type
    ) {
      if (this.multiSeatDrop) {
        if (
          dropSeat.hasOwnProperty("sb_booking_code") &&
          dropSeat.sb_booking_code
        ) {
          this.onClickClearSwap();
        } else {
          let errorCount = 0;
          let qty = this.SELECTED_BOOKED_SEATS.length;
          let checkIndexArray = [];
          for (
            let check = singleSeatIndex;
            check < singleSeatIndex + qty;
            check++
          ) {
            let dSeat =
              this.seatLayoutDataSwap[typeIndex].seatsFinal[rowIndex][check];
            let count = 0;
            if (dSeat && ![8, 2, 12, 13].includes(dSeat.seat_reserve_type_id)) {
              this.SELECTED_BOOKED_SEATS.map((seat) => {
                if (
                  (checkIndexArray.length == 0 ||
                    !checkIndexArray.some(
                      (y) =>
                        y.hasOwnProperty("swap_seat") &&
                        y.swap_seat.sl_id == seat.sl_id
                    )) &&
                  count == 0 &&
                  !this.checkSwapDone(seat)
                ) {
                  delete seat.screenSeatType;
                  dSeat["swap_seat"] = _.cloneDeep(seat);
                  dSeat["old_seat_reserve_type_id"] =
                    dSeat.seat_reserve_type_id;
                  dSeat["seat_reserve_type_id"] = 8;
                  dSeat["swapped"] = true;
                  dSeat["sb_booking_code"] = seat.sb_booking_code;
                  count++;
                  checkIndexArray.push(dSeat);
                } else {
                  console.log("COMING ELSE OF CHECK SOME OF ARRAY");
                }
              });
            } else {
              errorCount++;
              // checkIndexArray = [];
            }
          }

          if (errorCount > 0) {
            errorCount = 0;
            // checkIndexArray =[];
            let startIndex = singleSeatIndex - 1;
            let remainingQty = qty - checkIndexArray.length;
            for (
              let check = startIndex;
              check > startIndex - remainingQty;
              check--
            ) {
              let dSeat =
                this.seatLayoutDataSwap[typeIndex].seatsFinal[rowIndex][check];
              let count = 0;
              if (
                dSeat &&
                ![8, 2, 12, 13].includes(dSeat.seat_reserve_type_id)
              ) {
                this.SELECTED_BOOKED_SEATS.map((seat) => {
                  if (
                    (checkIndexArray.length == 0 ||
                      !checkIndexArray.some(
                        (y) =>
                          y.hasOwnProperty("swap_seat") &&
                          y.swap_seat.sl_id == seat.sl_id
                      )) &&
                    count == 0 &&
                    !this.checkSwapDone(seat)
                  ) {
                    delete seat.screenSeatType;
                    dSeat["swap_seat"] = _.cloneDeep(seat);
                    dSeat["old_seat_reserve_type_id"] =
                      dSeat.seat_reserve_type_id;
                    dSeat["seat_reserve_type_id"] = 8;
                    dSeat["swapped"] = true;
                    dSeat["sb_booking_code"] = seat.sb_booking_code;
                    count++;
                    checkIndexArray.push(dSeat);
                  } else {
                    console.log("COMING ELSE OF CHECK SOME OF ARRAY");
                  }
                });
              } else {
                errorCount++;
                // checkIndexArray = [];
              }
            }
          }

          if (errorCount > 0) {
            checkIndexArray = [];
            this.onClickClearSwap();
            this.$toasted.show("No Space");
            this.$forceUpdate();
          } else {
            checkIndexArray.map((x) => {
              this.SWAPED_BOOKED_SEATS.push(x);
              this.SWAPED_ALL_SEATS.push(x);
              if(!this.singleSwapCountFull && this.autoSaveSession) {
              this.onClickSaveSingleSwapSession();
            }
              this.$forceUpdate();
            });
            console.log("checkIndexArray", checkIndexArray);
            console.log("this.SWAPED_BOOKED_SEATS", this.SWAPED_BOOKED_SEATS);
            console.log("this.SWAPED_ALL_SEATS", this.SWAPED_ALL_SEATS);
          }
        }
      } else if (type == "drop") {
        this.handleDrop(
          data,
          dropSeat,
          singleSeatIndex,
          rowIndex,
          typeIndex,
          true
        );
      } else if (type == "click") {
        this.onClickDrop(dropSeat, singleSeatIndex, rowIndex, typeIndex);
      }
    },
    handleDrop(
      data,
      dropSeat,
      singleSeatIndex,
      rowIndex,
      typeIndex,
      showSeatWarning = false
    ) {
      console.log('handleDrop', data.seat.sl_seat_name);
      if (
        this.swapSeatFlag &&
        data.seat.hasOwnProperty("sb_booking_code") &&
        data.seat.sb_booking_code
      ) {
        if (this.checkSwapDone(data.seat)) {
          return this.$toasted.show("Already Swapped");
        } else if(this.checkOccupied(dropSeat)) {
           return this.$toasted.show("Seat Already Occupied");
        } else {
          delete data.seat.screenSeatType;
          dropSeat["swap_details"] = _.cloneDeep(data);
          dropSeat["swap_seat"] = _.cloneDeep(data.seat);
          dropSeat["old_seat_reserve_type_id"] = dropSeat.seat_reserve_type_id;
          dropSeat["seat_reserve_type_id"] = 8;
          dropSeat["swapped"] = true;
          dropSeat["sb_booking_code"] = data.seat.sb_booking_code;

          if (data.seat.srt_name != dropSeat.srt_name && showSeatWarning) {
            this.$toasted.show(
              `${data.seat.srt_name} has been swapped with ${dropSeat.srt_name}`, {
                type: 'error',
                position: 'top-right',
                duration: 4000,
                keepOnHover: true,
                theme: 'toasted-primary',
                singleton: true
              }
            );
          }
          
          this.SWAPED_BOOKED_SEATS.push(dropSeat);
          this.SWAPED_ALL_SEATS.push(dropSeat);

          if(!this.singleSwapCountFull && this.autoSaveSession) {
              this.onClickSaveSingleSwapSession();
            }
        }
        this.$forceUpdate();
      } else {
        console.log(
          "COMING TO ELSE ERROR: SELECT TRANSACTION/PROPER SEAT",
          data
        );
      }
    },
    dragEnter(data, singleSeat) {
      console.log("dragEnter data", data);
      console.log("dragEnter ON SEAT", singleSeat);
    },
    onSelectSwapSeatFlagClass(seat) {
      if (this.SELECTED_BOOKED_SEATS.includes(seat)) {
        return true;
      } else {
        return false;
      }
    },
    onClickBookedSeats(
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      if (
        (this.selectedScreen && this.swapType == 1) ||
        (this.selectedShow && this.swapType == 2)
      ) {
        if (!this.swapSeatFlag) {
          this.SWAPED_BOOKED_SEATS = [];
        }
        if (this.SELECTED_BOOKED_SEATS.includes(seat)) {
          this.SELECTED_BOOKED_SEATS = [];
          this.swapSeatFlag = false;
        } else if (
          seat.hasOwnProperty("sb_booking_code") &&
          seat.sb_booking_code
        ) {
          this.SELECTED_BOOKED_SEATS = [];
          this.swapSeatFlag = false;
          console.log("seat.sb_booking_code", seat.sb_booking_code);
          this.seatLayoutData.map((x, indexX) => {
            x.seatsFinal.map((y, indexY) => {
              y.map((z, indexZ) => {
                console.log("z.sb_booking_code", z.sb_booking_code);
                if (
                  z.sb_booking_code &&
                  z.sb_booking_code == seat.sb_booking_code
                ) {
                  this.swapSeatFlag = true;
                  z["seatRowIndex"] = rowIndex;
                  z["typeIndex"] = type;
                  this.SELECTED_BOOKED_SEATS.push(z);
                }
              });
            });
          });
        } else {
          this.$toasted.show("Please Select Booked Seats");
        }
      } else {
        if (this.swapType == 2) {
          this.$toasted.show("Please Select Show");
        } else if (this.swapType == 1) {
          this.$toasted.show("Please Select Screen");
        }
      }
      console.log("SELECTED_BOOKED_SEATS", this.SELECTED_BOOKED_SEATS);
    },
    getSeatTypes: function (screen) {
      let payload = {
        tableName: "ms_seat_reserve_types",
        srt_is_active: "Y",
      };
      this.seatTypes = [];
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.activeSeatTypes = data.Records;
            this.activeSeatTypes.map((x) => {
              let obj = {
                seatName: x.srt_name,
                size: x.srt_seat_capacity,
                value: x.srt_id,
                imageClass: "regular-seat",
                imageURL: this._GetImagePath(x.srt_dash_image_url),
              };
              if (x.srt_id == 1) {
                this.seatTypeSelected = obj;
              }
              this.seatTypes.push(obj);
            });
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    getSeatIconURL(singleSeat) {
      let iconPath = ``;
      if (singleSeat.selectStatus) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
      } else if (
        singleSeat.seat_reserve_type_id == 12 ||
        singleSeat.seat_reserve_type_id == 8
      ) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
      } else {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
      }
      return iconPath;
    },
    getSeatScreenType: function (screen_id) {
      let payload = {
        screenID: screen_id,
      };
      ScreenService.getSeatScreenType(payload)
        .then((result) => {
          const { data } = result;
          if (data.status && data.Records.length > 0) {
            this.screenSeatTypes = data.Records;
            this.getSwapScreenLayout(screen_id);
          }
        })
        .catch((err) => {});
    },
    getSwapScreenLayout(screen_id) {
      let loader = this.$loading.show();
      ExhibitorService.GetSwapScreenLayout({ screen_id: screen_id })
        .then((response) => {
          const { data } = response;
          let seats = data;
          if (seats && seats.status) {
            this.flag = true;
            this.seatLayoutDataSwap = [];

            let seatData_1 = groupBy(data.Records, "sl_row_num");
            this.screenSeatTypes = this.screenSeatTypes.sort(function (a, b) {
              return a.sst_order - b.sst_order;
            });
            let tempArray = [];
            for (let key in seatData_1) {
              if (seatData_1.hasOwnProperty(key)) {
                let seatData_2 = seatData_1[key].map((singleSeat) => {
                  singleSeat["seatName"] = singleSeat.sl_seat_name;
                  this.seatTypes.map((x) => {
                    if (x.value == singleSeat.seat_reserve_type_id) {
                      singleSeat["seatType"] = x;
                      singleSeat["selectStatus"] = false;
                      singleSeat["SelectStatusFlag"] = false;
                      singleSeat["seatTypeImageClass"] = x.imageClass;
                    }
                    this.screenSeatTypes.map((y) => {
                      if (y.sst_id == singleSeat.screen_seat_type_id) {
                        singleSeat["screenSeatType"] = y;
                        singleSeat["sst_seat_type"] = y.sst_seat_type;
                      }
                    });
                  });
                  return singleSeat;
                });
                tempArray.push(seatData_2);
              }
            }

            this.screenSeatTypes.map((x) => {
              x["seatsFinal"] = [];
              tempArray.map((y) => {
                if (x.sst_id == y[0].screenSeatType.sst_id) {
                  x.seatsFinal.push(y);
                }
              });
              this.seatLayoutDataSwap.push(x);
            });



            let tempSeatLayoutArray = _.cloneDeep(this.seatLayoutDataSwap);
            this.seatLayoutDataSwap = getSeatLayoutModified(_.cloneDeep(seats.Records), _.cloneDeep(this.screenSeatTypes), _.cloneDeep(tempSeatLayoutArray))
            console.log('tempSeatLayoutArray', tempSeatLayoutArray);
            console.log('seatLayoutDataSwap', this.seatLayoutDataSwap);
            // this.$store.dispatch("GET_Reserve_SEAT_LAYOUT", data);
          } else {
            vue.toasted.show(data.message || "Please try later");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    checkValidScreen(screen) {
      let errorCount = 0;
      let errmsg = "";

      if (!screen.screenAvailable) {
        errorCount++;
        errmsg = `Screen Not Available`;
      } else if (
        screen.videoFormats &&
        this.selectedShowDetails[0].movie_format_id
      ) {
        let videoFormats = screen.videoFormats.map((vf) => vf.mf_id);
        if (
          !videoFormats.includes(this.selectedShowDetails[0].movie_format_id)
        ) {
          errorCount++;
          errmsg = this.$t("videoFormatErrorPopup");
        }
      } else if (
        screen.soundFormats &&
        screen.soundFormats.length &&
        this.selectedShowDetails[0].sound_format_id
      ) {
        let soundFormats = screen.soundFormats.map((sf) => sf.sound_format_id);
        if (
          !soundFormats.includes(this.selectedShowDetails[0].sound_format_id)
        ) {
          errorCount++;
          errmsg = this.$t("soundFormatErrorPopup");
        }
      } else if (screen.screen_no_of_seats < this.totalBookingCount) {
        errorCount++;
        errmsg = `Screen Capacity is less than transactions`;
      }

      if (errorCount > 0) {
        this.$toasted.show(errmsg);
        return false;
      } else {
        return true;
      }
    },
     checkValidSchedule(show) {
      let errorCount = 0;
      let errmsg = "";
      let totalShowBookings = parseInt(show.booked_seats || 0) + parseInt(show.unpaid_count || 0)
      let screen_total_seats = parseInt(show.screen_total_seats || 0)
      let remainingSeats = parseInt(screen_total_seats) - parseInt(totalShowBookings)
      if (remainingSeats < this.totalBookingCount) {
        errorCount++;
        errmsg = `Screen Capacity is less than transactions`;
      }

      if (errorCount > 0) {
        this.$toasted.show(errmsg);
        return false;
      } else {
        return true;
      }
    },
    onSelectShow(show) {
      this.onClickCancelSwap();
      this.onClear();
      if(this.checkValidSchedule(show)) {
        this.selectedShowId = show.ss_id;
        this.getSeatLayoutMergeData(show.ss_id, show.md_id, show.screen_id);
      } else {
        this.seatLayoutDataSwap = [];
        this.selectedShowId = null;
        this.selectedShow = '';
        this.$forceUpdate();
      }
    },
    onSelectScreen(screen) {
      this.onClickCancelSwap();
      this.onClear();
      if (this.checkValidScreen(screen)) {
        this.selectedScreenId = screen.screen_id;
        this.getSeatScreenType(screen.screen_id);
      } else {
        this.seatLayoutDataSwap = [];
        this.selectedScreen = "";
        this.selectedScreenId = null;
        this.$forceUpdate();
      }
    },
    getScheduleShowDetails(ss_id) {
      let loader = this.$loading.show();
      ExhibitorService.GetScheduleDetails({ ss_id: ss_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.selectedShowDetails = data.Records;
            this.totalScreenSeats = data.Records[0].screen_total_seats || 0;
            this.booked_seats_count = data.Records[0].booked_seats || 0;
            this.unpaid_seats_count = data.Records[0].unpaid_count || 0;
            this.ScheduleDetails.movie_title = data.Records[0].movie_title;
            this.ScheduleDetails.movie_name = data.Records[0].movie_name;
            this.ScheduleDetails.md_id = data.Records[0].md_id;
            this.ScheduleDetails.screen_id = data.Records[0].screen_id;
            this.ScheduleDetails.cinema_name = data.Records[0].cine_name;
            this.ScheduleDetails.screen_name = data.Records[0].screen_name;
            this.ScheduleDetails.show_time = data.Records[0].ss_start_show_time;
            this.ScheduleDetails.show_date = moment(
              data.Records[0].ss_actual_start_date
            ).format("YY-MM-DD");
            console.log("ScheduleDetails", this.ScheduleDetails);
          } else {
            console.log("data.message", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getAvailabelScreenList(ss_id) {
      this.ScreenList = [];
      ExhibitorService.GetAvailableScreenList({ ss_id: ss_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.ScreenList = data.Records;
            this.ScreenList = this.ScreenList.sort((a, b) => {
              if (a.screenAvailable === false) {
                return 1;
              }
              if (b.screenAvailable === false) {
                return -1;
              }
              if (a == b) {
                return 0;
              }
              return a.screen_id < b.screen_id ? -1 : 1;
            });
          } else {
            this.ScreenList = [];
            console.log("data.message", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          $(".unavailbleScreen")
            .parent()
            .parent()
            .addClass("pointer-events unavailbleScreenOption");
        });
    },
    getAvailabelScheduleList(ss_id) {
      this.ScheduleList = [];
      ExhibitorService.GetAvailableScheduleList({ ss_id: ss_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.ScheduleList = data.Records;
          } else {
            this.ScheduleList = [];
            console.log("data.message", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {});
    },
    getSeatLayoutData: async function (ss_id, md_id, screen_id) {
      this.SetAllSeats = [];
      let loader = this.$loading.show();

      let data = {};

      let seats = await ExhibitorService.GetMovieScreenLayout({
        screen_id: screen_id,
        ss_id: ss_id,
        md_id: md_id,
      });
      data.seats = seats.data;

      let seatType = await PosService.getSeatType({
        screen_id: screen_id,
        ss_id: ss_id,
        md_id: md_id,
      });
      data.seatType = seatType.data;

      if (seats && seats.status) {
        this.flag = true;
        loader.hide();
        this.seatLayoutData = [];

        let seatData_1 = groupBy(data.seats.Records, "sl_row_num");
        data.seatType.Records = data.seatType.Records.sort(function (a, b) {
          return a.sst_order - b.sst_order;
        });
        let tempArray = [];
        for (let key in seatData_1) {
          if (seatData_1.hasOwnProperty(key)) {
            let seatData_2 = seatData_1[key].map((singleSeat) => {
              singleSeat["seatName"] = singleSeat.sl_seat_name;
              this.seatTypes.map((x) => {
                if (x.value == singleSeat.seat_reserve_type_id) {
                  singleSeat["seatType"] = x;
                  singleSeat["selectStatus"] = false;
                  singleSeat["SelectStatusFlag"] = false;
                  singleSeat["seatTypeImageClass"] = x.imageClass;
                }
                data.seatType.Records.map((y) => {
                  if (y.sst_id == singleSeat.screen_seat_type_id) {
                    singleSeat["screenSeatType"] = y;
                    singleSeat["sst_seat_type"] = y.sst_seat_type;
                  }
                });
              });
              return singleSeat;
            });
            tempArray.push(seatData_2);
          }
        }

        data.seatType.Records.map((x) => {
          x["seatsFinal"] = [];
          tempArray.map((y) => {
            if (x.sst_id == y[0].screenSeatType.sst_id) {
              x.seatsFinal.push(y);
            }
          });
          this.seatLayoutData.push(x);
        });

        let tempSeatLayoutArray = _.cloneDeep(this.seatLayoutData);
        this.seatLayoutData = getSeatLayoutModified(_.cloneDeep(data.seats.Records), _.cloneDeep(data.seatType.Records), _.cloneDeep(tempSeatLayoutArray))
        // this.$store.dispatch("GET_Reserve_SEAT_LAYOUT", data);
      } else {
        loader.hide();
        vue.toasted.show(data.message || "Please try later");
      }
    },
    getSeatLayoutMergeData: async function (ss_id, md_id, screen_id) {
      this.SetAllSeats = [];
      let loader = this.$loading.show();

      let data = {};

      let seats = await ExhibitorService.GetMovieScreenLayout({
        screen_id: screen_id,
        ss_id: ss_id,
        md_id: md_id,
      });
      data.seats = seats.data;

      let seatType = await PosService.getSeatType({
        screen_id: screen_id,
        ss_id: ss_id,
        md_id: md_id,
      });
      data.seatType = seatType.data;

      if (seats && seats.status) {
        this.flag = true;
        loader.hide();
        this.seatLayoutDataSwap = [];

        let seatData_1 = groupBy(data.seats.Records, "sl_row_num");
        data.seatType.Records = data.seatType.Records.sort(function (a, b) {
          return a.sst_order - b.sst_order;
        });
        let tempArray = [];
        for (let key in seatData_1) {
          if (seatData_1.hasOwnProperty(key)) {
            let seatData_2 = seatData_1[key].map((singleSeat) => {
              singleSeat["seatName"] = singleSeat.sl_seat_name;
              this.seatTypes.map((x) => {
                if (x.value == singleSeat.seat_reserve_type_id) {
                  singleSeat["seatType"] = x;
                  singleSeat["selectStatus"] = false;
                  singleSeat["SelectStatusFlag"] = false;
                  singleSeat["seatTypeImageClass"] = x.imageClass;
                }
                data.seatType.Records.map((y) => {
                  if (y.sst_id == singleSeat.screen_seat_type_id) {
                    singleSeat["screenSeatType"] = y;
                    singleSeat["sst_seat_type"] = y.sst_seat_type;
                  }
                });
              });
              return singleSeat;
            });
            tempArray.push(seatData_2);
          }
        }

        data.seatType.Records.map((x) => {
          x["seatsFinal"] = [];
          tempArray.map((y) => {
            if (x.sst_id == y[0].screenSeatType.sst_id) {
              x.seatsFinal.push(y);
            }
          });
          this.seatLayoutDataSwap.push(x);
        });

        let tempSeatLayoutArray = _.cloneDeep(this.seatLayoutDataSwap);
        this.seatLayoutDataSwap = getSeatLayoutModified(_.cloneDeep(data.seats.Records), _.cloneDeep(data.seatType.Records), _.cloneDeep(tempSeatLayoutArray))
        // this.$store.dispatch("GET_Reserve_SEAT_LAYOUT", data);
      } else {
        loader.hide();
        vue.toasted.show(data.message || "Please try later");
      }
    },
    OnSave: async function () {
      let loader = this.$loading.show();
      let finalProcessingArray = [];
      let groupedFinalArray = [];
      let finalSubmitArray = [];
      this.$refs.swapConfirmation.show();
      if (this.totalBookingCount != this.SWAPED_ALL_SEATS.length) {
        return this.$toasted.show("Please Swap All transactions");
      } else {
        this.disableBtn = true;

        finalProcessingArray = [
          ...new Map(
            this.SWAPED_ALL_SEATS.map((item) => [item["sl_id"], item])
          ).values(),
        ];

        groupedFinalArray = _.toPairs(
          _.groupBy(
            finalProcessingArray.filter((x) => x),
            "sb_booking_code"
          )
        );

        groupedFinalArray.map((group) => {
          console.log("group", group);
          let bookingObj = {
            sb_booking_code: "",
            reservation_id: "",
            sb_id: null,
            schedule_show_id: null,
            new_schedule_show_id: null,
            md_id: null,
            old_screen_id: null,
            new_screen_id: null,
            swapType: this.swapType,
            seats: [],
          };
          group[1].map((seats, index) => {
            console.log("seats", seats);
            if (index == 0) {
              bookingObj["sb_booking_code"] = seats.swap_seat.sb_booking_code;
              bookingObj["reservation_id"] = seats.swap_seat.reservation_id;
              bookingObj["sb_id"] = !!seats.swap_seat.sb_id ? seats.swap_seat.sb_id : null;
              bookingObj["schedule_show_id"] = seats.swap_seat.schedule_show_id;
              bookingObj["new_schedule_show_id"] = this.swapType == 2 ? this.selectedShowId : null;
              bookingObj["old_screen_id"] = seats.swap_seat.screen_id;
              bookingObj["new_screen_id"] = seats.screen_id;
              bookingObj["md_id"] = this.ScheduleDetails.md_id;
            }
            delete seats.screenSeatType;
            bookingObj["seats"].push(seats);
          });
          finalSubmitArray.push(bookingObj);
        });

        let payload = {
          md_id: this.routerParams.md_id,
          screen_id: this.routerParams.screen_id,
          ss_id: this.routerParams.ss_id,
          new_ss_id: this.swapType == 2 ? this.selectedShowId : null,
          type: this.swapType,
          swap_reason: this.swapReason || null,
          booking_array: finalSubmitArray,
        };

        console.log("payload", payload);
        // this.$toasted.show('TEST VERSION OF MERGE')
        // loader.hide();
        // return;

        ExhibitorService.SwapAuditorium(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.$router.go(-1);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show("Something Went Wrong! ERR CODE: 1263");
            console.log("ERROR IN SWAP", err);
          })
          .finally(() => {
            this.disableBtn = false;
            loader.hide();
          });
      }
    },
    onClear: async function () {
      console.log("ONC CLICK CLEAR", this.SWAPED_ALL_SEATS);
      let selected_booked_seat_ids = this.SWAPED_ALL_SEATS.map(
        (x) => x.hasOwnProperty("swap_seat") && x.swap_seat.sl_id
      );

      this.SWAPED_ALL_SEATS = [];

      this.seatLayoutDataSwap.map((x, xIndex) => {
        x.seatsFinal.map((y, yIndex) => {
          y.map((z) => {
            if (
              z.hasOwnProperty("swap_seat") &&
              selected_booked_seat_ids.includes(z.swap_seat.sl_id)
            ) {
              z["seat_reserve_type_id"] = z.old_seat_reserve_type_id;
              delete z.swap_details;
              delete z.swap_seat;
              delete z.old_seat_reserve_type_id;
              delete z.sb_booking_code;
              this.$forceUpdate();
            }
          });
        });
      });
    },
  },
};
</script>

<style>

.disSwapBtn {
  opacity: 0.4 !important;
}
.grey {
  background-color: lightgray;
}
.disabledSaveBtn {
  pointer-events: none;
  cursor: not-allowed;
}
.pos-seat-border {
  margin: 0 auto;
  min-width: 30px;
  height: 30px;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  border: 1px solid #3876d2 !important;
}
.seatNameSmall {
  position: absolute;
  width: 28px;
  height: 28px;
  margin: auto;
  top: 5px;
  font-size: 11px;
  font-weight: bold;
}
.fs-13 {
  font-size: 13px;
}
.my-seat-popover {
  max-width: 260px !important;
}
.zoomOut9 {
  zoom: 0.9;
}
.disabled-other-seats {
  opacity: 0.2;
  /* pointer-events: none; */
}
.selected_swap_seats {
  box-shadow: 0px 2px 5px 1px #1dbe40;
}
.swap_no-border {
  box-shadow: unset !important;
}
.unavailbleScreenText {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 10px !important;
}
.reserve-seat-layout {
  margin: 0 auto;
}
.normal-seat {
  display: none !important;
}

.reserve-seat-layout td {
  padding: 5px;
}
.reserve-seat-layout .cinema-seat {
  background-color: var(--blue);
}
.fs-22 {
  font-size: 22px;
}
.border-right-dotted {
  border-right: 3px dotted black;
}
.unavailbleScreen {
  color: red;
}

.unavailbleScreenOption {
  opacity: 0.5;
}

.highlight-seats {
  box-shadow: 1px 1px 9px 0px #6f6f6f !important;
}

.swap-auditorium-container .pos-seat {
  border: none !important;
}
.noScreen {
  display: flex;
  justify-content: center;
  align-items: center;
}
.infoBtnClass {
  background: black;
    border-radius: 50%;
    height: 25px;
    width: 26px;
    box-shadow: darkgrey 1px 2px 3px 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SwapAuditorium/swapAuditorium.vue